import script from "./ScrollHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollHero.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollHero.vue?vue&type=style&index=0&id=210c49bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-210c49bc"]])

export default __exports__